import { useMemo, useCallback } from 'react';

const useTableSelectBox = ({
  selectBoxOptions,
  pageSize,
  filters,
  sorting,
  updateParams,
}) => {
  const selectedValue = useMemo(() => {
    if (!selectBoxOptions) return '';

    return filters[selectBoxOptions.field] || '';
  }, [selectBoxOptions, filters]);

  const handleSelectChange = useCallback(
    e => {
      if (!selectBoxOptions) return;

      const newFilters = { ...filters };
      const value = e.target.value;

      if (value) {
        newFilters[selectBoxOptions.field] = value;
      } else {
        delete newFilters[selectBoxOptions.field];
      }

      updateParams({
        pageIndex: 0,
        pageSize,
        filters: newFilters,
        sorting,
      });
    },
    [selectBoxOptions, pageSize, filters, sorting, updateParams],
  );

  return {
    selectedValue,
    handleSelectChange,
  };
};

export default useTableSelectBox;
